import { Button, DeprecatedTable, Modal, Text } from '@sede-enterprise/shell-ds-react-framework';
import { useEffect, useReducer, useContext } from 'react';
import styled from 'styled-components';
import Step2Image from '../../images/Step2_empty.png';
import Loader from '../Loader';
import '../CalculatorForm/CalculatorForm.css';
import { AppContext } from '../../context/calculatorFormContext';
import { inputTableReducer } from '../../reducers/ActionHandlers/InputTableActionHandler';
import { inputTableInitialState } from '../../reducers/InitialStates/InputTableInitialState';
import {
  decorateTableData,
  tableCols,
  resetTable,
  getOutputKpi,
  bootstrapCol,
} from './InputTableFunctions';

const Container = styled.div`
  overflow: scroll;
`;

const InputTableContent = () => {
  const { state, dispatch } = useContext(AppContext);
  const [myState, myDispatch] = useReducer(inputTableReducer, inputTableInitialState);
  const firstColData: string[] = ['Total Volume'];

  const tableHeadingOne = state.stepTwoTableFirstCol;

  useEffect(() => {
    // set all the column headers
    let col: Array<string | number> = [tableHeadingOne];
    col = bootstrapCol(col, state, firstColData, myDispatch);
    decorateTableData(firstColData, dispatch, col);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isGoToStepTwoClicked]);

  return state.isFormValidated ? (
    <>
      <Loader isLoading={myState.isLoading} message={'Fetching Carbon Intensities'} />
      <Modal
        open={state.isGetOutputKpiServiceFailure}
        onClose={() => {
          dispatch({
            type: 'setIsGetOutputKpiServiceFailure',
            payload: false,
          });
        }}
      >
        We ran into issues. Please re-try.
      </Modal>
      <Modal
        open={myState.isPasteDataFailure}
        onClose={() => {
          myDispatch({
            type: 'setIsPasteDataFailure',
            payload: false,
          });
        }}
      >
        Only positive numbers, positive decimals and 0 are valid inputs.
      </Modal>
      <Container>
        <DeprecatedTable
          size='small'
          data={state.stepTwoTableData}
          columns={tableCols(state, dispatch, myState, tableHeadingOne, myDispatch)}
          tableLayout='fixed'
          rowKey={state.stepTwoTableFirstCol}
          wrapperStyle={{
            textAlign: 'left',
          }}
        />
      </Container>
      {(() => {
        const normalizeEvpName = (evpName: string): string => evpName.toLowerCase().replace(/[^a-z0-9]/g, '');
        return normalizeEvpName(state.evp) === 'tsproducts';
      })() && (
        <div style={{ marginTop: '16px', marginBottom: '16px' }}>
          <Text type='span' style={{ fontStyle: 'italic', color: '#666' }}>
            TSP specific note: Ethanol, HVO and FAME should include both blended and unblended
            volumes
          </Text>
        </div>
      )}
      <div className='align-btns-right-input-table'>
        <Button
          className='btn-size margin-right'
          variant='outlined'
          onClick={() => {
            resetTable(state, dispatch);
          }}
        >
          Reset Table
        </Button>
        <Button
          variant='filled'
          className='btn-size'
          onClick={() => {
            void getOutputKpi(state, dispatch, myDispatch);
          }}
        >
          Get Output KPIs
        </Button>
      </div>
    </>
  ) : (
    <>
      <Text type='span' className='flex-display-start'></Text>
      <div className='margin-top empty-state-image'>
        <img src={Step2Image} width='90' height='90' alt='KPI Table' />
        <p className='empty-state-sub-label'>
          Please enter the fields in Step 01 to generate the input table
        </p>
      </div>
      {/* <DataGrid></DataGrid> */}
    </>
  );
};

export default InputTableContent;
